import React from 'react'
import ButtonLink, { ButtonLinkProps } from 'components/shared/ButtonLink'

const MyAccountButton: React.FC<Omit<ButtonLinkProps, 'text' | 'to'>> = ({ ...props }) => {
  return <ButtonLink variant='outlined' text='My Account' to='/client/my-account' size='large' bold {...props} />
}

export default MyAccountButton
